import { setLocalState, getInitialState } from "../helpers/state"
import Fletch from '../helpers/fletch'
import { API_ROOT } from './constants'

export const auth = new Fletch({ root: API_ROOT })

const store = ({ data }) => setLocalState({
  [data.creation]: data
})

export const submit = async (data) => {
  try {
    // If we don't have correct data, warn
    if(!data.creation) console.warn('No creation provided')
    if(!data.rating) console.warn('No rating provided')

    // Get local review data based on creation
    const prevReview = getInitialState(data.creation)

    // If a user has left a local review, update it based on ID
    // with user_edited set to true
    const res = prevReview
      // Update previous reviews based on ID, and mark as edited
      ? await auth.post(`mv-create/v1/reviews/${prevReview.id}`, { ...data, edited_by_user: 1 })
      // Create new review if previous doesn't exist
      : await auth.post(`mv-create/v1/reviews`, data)

    store(res)
    return res
  } catch(err) {
    return err
  }
}